import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import {ApiUrl} from "../../shared/models/apiurl.models";
import {ReelItem} from "./reels.model";
import {SystemApp} from "../../constans/SystemConfigurations";


// ─── Response types ───

export interface ReelsPagination {
    page: number;
    page_size: number;
    total_pages: number;
    total_count: number;
    has_next: boolean;
    has_previous: boolean;
}

export interface ReelsResponse {
    results: ReelItem[];
    pagination: ReelsPagination;
}

export type ModelClass = 'pet' | 'car' | 'sale2' | 'required' | 'coworker' | 'nadlan' | 'teacher';
export type SortOption = 'newest' | 'oldest' | 'price_asc' | 'price_desc';

// ─── Feed params (GET) ───

export interface ReelsFeedParams {
    model_class?: ModelClass;
    city?: number;
    region?: number;
    price_min?: number;
    price_max?: number;
    sort?: SortOption;
    limit?: number;
    offset?: number;
}

// ─── Search body (POST) ───

export interface ReelsSearchBody {
    city?: number;
    City?: number;
    region?: number;
    freeAdoption?: boolean;
    exchange?: boolean;
    DeliveryOffer?: boolean;
    armatureList?: string;
    petType?: number;
    breed?: number;
    gender?: number;
    age?: number;
    size?: number;
    listingType?: number;
    jobCategory?: number;
    jobType?: number;
    workLocationType?: number;
    professionCategory?: number;
    serviceType?: number;
    TypeOfNadlan?: number;
    Color?: number;
    ProductStatus?: number;
    price_min?: number;
    price_max?: number;
    [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class ReelsService {
    private options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.apiUrl.getJWTToken()
        })
    }
    private baseUrl = SystemApp.base_url_api; // e.g. 'https://api.sale4all.co.il'

    constructor(private http: HttpClient, private apiUrl: ApiUrl) {}

    /**
     * GET /api/reels/
     * GET /api/reels/?model_class=pet&limit=20&city=338&sort=newest
     */
    getFeed(params: ReelsFeedParams = {}): Observable<ReelsResponse> {
        let httpParams = new HttpParams();

        if (params.model_class) httpParams = httpParams.set('model_class', params.model_class);
        if (params.city)        httpParams = httpParams.set('city', params.city.toString());
        if (params.region)      httpParams = httpParams.set('region', params.region.toString());
        if (params.price_min)   httpParams = httpParams.set('price_min', params.price_min.toString());
        if (params.price_max)   httpParams = httpParams.set('price_max', params.price_max.toString());
        if (params.sort)        httpParams = httpParams.set('sort', params.sort);
        if (params.limit)       httpParams = httpParams.set('limit', params.limit.toString());
        if (params.offset)      httpParams = httpParams.set('offset', params.offset.toString());

        return this.http.get<ReelsResponse>(`${this.baseUrl}/api/socialmedia/reels/`, { params: httpParams, headers: this.options.headers});
    }

    /**
     * GET /api/reels/{id}/
     */
    getReelById(id: number): Observable<ReelItem> {
        return this.http.get<ReelItem>(`${this.baseUrl}/api/socialmedia/${id}/`);
    }

    /**
     * POST /api/reels/search/?model_class=pet&offset=1&limit=50
     */
    search(
        modelClass: ModelClass,
        body: ReelsSearchBody = {},
        offset = 1,
        limit = 50,
        sort: SortOption = 'newest'
    ): Observable<ReelsResponse> {
        const httpParams = new HttpParams()
            .set('model_class', modelClass)
            .set('offset', offset.toString())
            .set('limit', limit.toString())
            .set('sort', sort);

        return this.http.post<ReelsResponse>(
            `${this.baseUrl}/api/reels/search/`,
            body,
            { params: httpParams }
        );
    }
}